import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AccountDto } from '../../../data/models/account-dto';
import { AccountService } from '../../../services/account.service';
import { AppService } from '../../../services/app.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  providers: [MessageService]
})
export class MainComponent implements OnInit {
  public sidebarMenuOpened = true;
  @ViewChild('contentWrapper', { static: false }) contentWrapper;

  accountDetails: AccountDto;
 
  constructor(private renderer: Renderer2, private appService: AppService,
    private messageService: MessageService, private accountService: AccountService,) { }

  ngOnInit() {
    if (sessionStorage.getItem('loginTime')) {
      let time = new Date(sessionStorage.getItem('loginTime')).getTime();
      let now = new Date();
      if (new Date(time + 86400000) < now) {
        this.appService.logout();
      }
    }
    this.toggleMenuSidebar();


    this.renderer.removeClass(document.querySelector('app-root'), 'login-page');
    this.renderer.removeClass(
      document.querySelector('app-root'),
      'register-page'
    );

    
  }

  mainSidebarHeight(height) {
  
  }

  toggleMenuSidebar() {
    if (this.sidebarMenuOpened) {
      this.renderer.removeClass(
        document.querySelector('app-root'),
        'sidebar-open'
      );
      this.renderer.addClass(
        document.querySelector('app-root'),
        'sidebar-collapse'
      );
      this.sidebarMenuOpened = false;
    } else {
      this.renderer.removeClass(
        document.querySelector('app-root'),
        'sidebar-collapse'
      );
      this.renderer.addClass(
        document.querySelector('app-root'),
        'sidebar-open'
      );
      this.sidebarMenuOpened = true;
    }
  }

  
}
